<template>
    <div style="position: relative;">
        <template v-if="popupType === POPUP_TYPE.REJECT">
            <CommonConfirmFrame :containerWidth="'calc(100% - 24px)'" :isShowConfirmPopup="isShowRejectConfirmPopup" :closeConfirmPopup="closeAction">
                <div class="common_container">
                    <div class="common_circle red">
                        <img style="width: 20px;" :src="require('@/assets/img/broken_heart_red.png')" alt="" />
                    </div>
                    <div class="common_title">매칭이 이루어지지 않았습니다.</div>
                    <div class="reject_text"><span>{{ direct_message.team.name + ' ' + direct_message.from_member.nic_name }}감독</span>이 <br>회원님께 전하는 응원의 한마디입니다.</div>
                    <div class="feedback_container">
                        <div class="feedback_contents">{{ direct_message.feedback }}</div>
                    </div>
                    <div class="btn_wrapper">
                        <div @click="closeAction" class="common_btn go_out">나가기</div>
                        <div @click="goReport" class="common_btn go_report">요청서 리포트 보기</div>
                    </div>
                </div>
            </CommonConfirmFrame>
        </template>
        <template v-if="popupType === POPUP_TYPE.CHAT_OPEN">
            <CommonConfirmFrame :containerWidth="'calc(100% - 24px)'" :isShowConfirmPopup="isShowChatOpenConfirmPopup" :closeConfirmPopup="closeChatOpenAction">
                <div>
                    <div class="common_circle_small" style="background-color: #FF711133;">
                        <img style="width: 16px" :src="require('@/assets/img/letter.png')" alt="">
                    </div>
                    <div style="margin-top: 15px; text-align: center;">
                        <div style="font-weight: 700; font-size: 20px; line-height: 24px;">매칭이 성사되었습니다! 🎉</div>
                        <div v-if="right_member.is_coach == 1" style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 5px;">
                            <span style="color: var(--color-main);">{{ right_member.nic_name }}감독님</span>과 연결되었습니다.<br>감독님과 소통을 시작해보세요
                        </div>
                        <div v-else style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 5px;">
                            <span style="color: var(--color-main);">{{ right_member.nic_name }}선수</span>와 연결되었습니다.<br>선수와 소통을 시작해 보세요
                        </div>
                    </div>
                    <div class="profile_connection">
                        <div class="profile_section">
                            <div class="profile_image_wrapper">
                                <ProfileImage :imagePath="left_member.image_path" />
                            </div>
                            <div class="profile_name_row">
                                <span class="profile_name">{{ left_member.nic_name }}</span>
                                <span v-if="left_member.is_coach == 0" class="position_text">{{ left_member.position }}</span>
                                <img v-else class="star_icon" :src="require('@/assets/img/coach_star_yellow.png')" alt="" />
                            </div>
                        </div>
                        <div class="connection_dots">
                            <span v-for="i in 5" :key="i" class="dot"></span>
                        </div>
                        <div class="profile_section">
                            <div class="profile_image_wrapper">
                                <ProfileImage :imagePath="right_member.image_path" />
                            </div>
                            <div class="profile_name_row">
                                <span class="profile_name">{{ right_member.nic_name }}</span>
                                <span v-if="right_member.is_coach == 0" class="position_text">{{ right_member.position }}</span>
                                <img v-else class="star_icon" :src="require('@/assets/img/coach_star_yellow.png')" alt="" />
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 0;" class="btn_wrapper">
                        <div @click="showChat" style="background-color: #111725; color: #fff; flex: 1;" class="common_confirm_btn confirm">확인</div>
                    </div>
                </div>
            </CommonConfirmFrame>
        </template>
    </div>
</template>

<script>
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame.vue'
import ProfileImage from '@/components/common/ProfileImage.vue'
import { POPUP_TYPE, MEMBER_TYPE, JOIN_CHAT_TYPE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'DirectMessagePopupModal',
    components: {
        CommonConfirmFrame,
        ProfileImage
    },
    data() {
        return {
            isShowRejectConfirmPopup: true,
            isShowChatOpenConfirmPopup: true,
            POPUP_TYPE: POPUP_TYPE,
            MEMBER_TYPE: MEMBER_TYPE,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE
        }
    },
    props: {
        popupType: {
            type: String,
            default: POPUP_TYPE.REJECT
        },
        direct_message: {
            type: Object,
            default: () => { }
        },
        left_member: {
            type: Object,
            default: () => { }
        },
        right_member: {
            type: Object,
            default: () => { }
        },
        chat_idx: {
            type: [Number, String],
            default: -1
        }
    },
    methods: {
        async confirmPopup() {
            const parameters = {};
            parameters.chat_idx = this.chat_idx;
            const res = await this.$Axios.post('/api/chat/coach_chat/confirmed', parameters);
            if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async changeRejectPopupStatus() {
            const formData = new FormData()
            formData.append('direct_message_idx', this.direct_message.idx)
            await this.$Axios.post('/api/direct_message/taken/reject/change', formData)
        },
        closeAction() {
            this.$GlobalStore.closeLastModal()
            this.changeRejectPopupStatus()
        },
        async closeChatOpenAction() {
            await this.confirmPopup();
            this.$GlobalStore.closeLastModal()
        },
        goReport() {
            this.closeAction()
            this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: this.direct_message.refer_idx, direct_message_idx: this.direct_message.idx })
        },
        async showChat() {
            await this.confirmPopup();
            this.$GlobalStore.closeLastModal();
            await this.$Axios.showChattingBySoccerJoinIdx(this.chat_idx);
        },
    }
}
</script>

<style scoped>
.common_container {
    padding: 8px;
    text-align: center;
}

.common_circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.red {
    background-color: #FEF0F0;
}

.common_title {
    margin-top: 15px;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

.reject_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #808080;
    margin-top: 5px;

}

.reject_text span {
    font-weight: 700;
    color: var(--color-main);
}

.feedback_container {
    margin-top: 20px;
    padding: 10px 20px;
    border-radius: 12px;
    background-color: #f8f8f8;
    text-align: left;
}

.feedback_contents {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
}

.btn_wrapper {
    margin-top: 30px;
    display: flex;
    gap: 18px;
}

.common_btn {
    padding: 14px 0;
    line-height: 18px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
}

.go_out {
    flex-basis: 35%;
    border: 1px solid #808080;
}

.go_report {
    flex-basis: 65%;
    background-color: var(--color-main);
    color: #fff;
}

.common_circle_small {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.profile_connection {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 20px 0;
}

.profile_section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.profile_image_wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
}

.profile_image_wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile_name_row {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
}

.profile_name {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #000;
}

.star_icon {
    width: 13px;
}

.position_text {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #FF7111;
}

.connection_dots {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 26px;
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #D9D9D9;
}

.common_confirm_btn {
    padding: 14px 0;
    line-height: 18px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
}
</style>